import React, { memo } from "react";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { Svg24 as ClearFilled } from "@swiggy-private/dls-web-icons/dist/web/generic/clearFilled";
import { Images } from "../../../constants/images";
import { DLS_TEXT_VARIANTS } from "../../../constants/dls";
import {
    ModalOverlay,
    ModalContent,
    CloseButton,
    FailureImage,
    ModalTitle,
    ModalButton,
} from "../../../styles/referralModal";

interface ReferralFailureModalProps {
    onClose: () => void;
    errorMessage?: string;
    buttonText?: string;
    onButtonClick?: () => void;
}

const ReferralFailureModal = ({
    onClose,
    errorMessage = "Something went wrong!",
    buttonText = "Try Again",
    onButtonClick,
}: ReferralFailureModalProps) => {
    const handleButtonClick = () => {
        onClose();
        onButtonClick?.();
    };

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent>
                <CloseButton onClick={onClose}>
                    <GenericIcon Icon={ClearFilled} fillColor="text_Med_Emphasis" />
                </CloseButton>
                <FailureImage src={Images.redWarning} />
                <ModalTitle variant={DLS_TEXT_VARIANTS.HEADING_H2_BOLD}>{errorMessage}</ModalTitle>
                <ModalButton variant="primary" onClick={handleButtonClick}>
                    {buttonText}
                </ModalButton>
            </ModalContent>
        </ModalOverlay>
    );
};

export default memo(ReferralFailureModal);
